﻿

export function extendTransitions(ICO){
   Object.assign(ICO,
   {
   
      tryAgain : function(){
         

         ICO.callError(ICO.vars.bigError);
      },
      callError : function(msg){
         ICO.vars.div.innerHTML = '';
         var errorAlert = document.createElement('p');
         errorAlert.setAttribute('class','ICO-alerts');
         errorAlert.appendChild(document.createTextNode(msg));
         ICO.vars.div.appendChild(errorAlert);
         
      },
      errorHTML : function(msg){
         ICO.vars.div.innerHTML = msg;
         
      },
      
      viewSwitch : function(id){
         ICO.clearAlerts();
         var len = ICO.views.length;
         for (var i=0; i < len; i++){
            if (ICO.views[i] == id){
               document.getElementById(id).style.display = 'block';
            } else {
               document.getElementById(ICO.views[i]).style.display = 'none';
            }
         }
         
         var len2 = ICO.viewsBc.length; 			
         if ( id == 'ICO-waiting'){
            for (var i=0; i < len2; i++){
               //console.log(ICO.viewsBc[i]);
               document.getElementById(ICO.viewsBc[i]).classList.remove('ICO-breadcrumbs-active');
            }
         }else if (id == 'ICO-success'){
                   for (var i=0; i < len2; i++){
                      document.getElementById(ICO.viewsBc[i]).classList.add('ICO-breadcrumbs-active');
                      
                      document.getElementById(ICO.viewsBc[i]).appendChild(document.createTextNode(' ✓'));
                   }
           } else{ 
            for (var i=0; i < len2; i++){
               document.getElementById(ICO.viewsBc[i]).classList.remove('ICO-breadcrumbs-active');  
            } 	
            
            var bcid	= id+'-bc';
            //console.log(bcid);
            document.getElementById(bcid).classList.add('ICO-breadcrumbs-active');		
         }
         

         
         
         
       //location.hash = 'ICO-top';
 
      },
      
      clearAlerts : function(){
         document.getElementById('ICO-form-alerts').innerHTML='';
         document.getElementById('ICO-alert').innerHTML=''; 
         document.getElementById('ICO-ship-alerts').innerHTML='';	
         document.getElementById('ICO-pay-alerts').innerHTML='';	
         if (ICO.settings.qrcard.enabled === true){
            document.getElementById('ICO-vCard-alert').innerHTML='';	
         }
         		
      },
      
      clearCalcDates: function(array){
         if (array.length !== 0){
            array.forEach(function(div) {
               // Find the input element inside the current div
               const input = div.querySelector('input');
               // Check if an input element is found
               if (input) {
                  // Set the input value to an empty string
                  input.value = '';
               }
            });
         }
      },

      approvedCard : function(){
         ICO.viewSwitch('ICO-shipping');
         ICO.finalizeCard();
      },
      
      nextBack : function(text, id, idn, idb){
 //DEPRECATED! replace use of this with makeButtons Function... until then, this function just rerouts to that. 
       
      var nFcn = 'ICO.viewSwitch(\"' + idn + '\")';
      
      ICO.makeButtons(idb, id, text, nFcn);
      
      },
      
      makeButtons : function(
                     back, //"back" is the id for the previous div, 
                     div, //"div" is the div where the buttons will be inserted, 
                     txt, //"txt" is the txt that goes into the next button, 
                     fcn){ //"fcn" is the function the next button triggers   

      var t = document.createElement('table');
         t.setAttribute('id', 'ICO-'+txt+'-button-table');
         t.setAttribute('class','ICO-button-table');
      var tr = document.createElement('tr');
         t.appendChild(tr);
      var td1 = document.createElement('td');
         td1.setAttribute('id', 'ICO-back-'+txt);
         tr.appendChild(td1);
      var td2 = document.createElement('td');
         td2.setAttribute('id', 'ICO-forward-'+txt);	
         tr.appendChild(td2);
      document.getElementById(div).appendChild(t);
      //back button
      var backButtonWrap = document.createElement('div');
         backButtonWrap.setAttribute('class','ICO-upload-btn ICO-center ICO-submit-button');
         backButtonWrap.setAttribute('onclick','ICO.viewSwitch(\''+back+'\')');
         backButtonWrap.setAttribute('id','back-'+div);
         td1.appendChild(backButtonWrap);
      var backButton = document.createElement('button');
         backButton.setAttribute('class','ICO-btn ICO-center');
         backButton.appendChild(document.createTextNode('← Go Back'));
         backButtonWrap.appendChild(backButton);
         td1.appendChild(backButtonWrap);
      //forward button
      var nextButtonWrap = document.createElement('div');
         nextButtonWrap.setAttribute('class','ICO-upload-btn ICO-center ICO-submit-button');
         nextButtonWrap.setAttribute('onclick', fcn);
         nextButtonWrap.setAttribute('id','next-'+div);
         td2.appendChild(nextButtonWrap);
      var nextButton = document.createElement('button');
         nextButton.setAttribute('class','ICO-btn ICO-center');
         nextButton.appendChild(document.createTextNode(txt));
         nextButtonWrap.appendChild(nextButton);      
      },

      basicButton : function(
                     div, //where the button goes
                     txt, //button text
                     id, //element id
                     fcn //function that button triggers
                     ){
         var ButtonWrap = document.createElement('div');
            ButtonWrap.setAttribute('class','ICO-upload-btn ICO-center ICO-submit-button');
            ButtonWrap.style.width="100%";
            ButtonWrap.setAttribute('onclick', fcn);
            ButtonWrap.setAttribute('id','wrap-'+id);
            div.appendChild(ButtonWrap);
         var Button = document.createElement('button');
            Button.setAttribute('class','ICO-btn ICO-center');
            Button.setAttribute('id', id);
            Button.appendChild(document.createTextNode(txt));
            ButtonWrap.appendChild(Button);      
      },

      byteCount(s){        
         var encoded = encodeURI(s);

         // Initialize byte count
         var count = 0;
     
         // Iterate over each character in the encoded string
         for (var i = 0; i < encoded.length; i++) {
             var char = encoded.charAt(i);
             if (char === '%') {
                 // If the character is a percent sign, the next two characters are the hex code of a byte
                 count += 1;
                 i += 2; // Skip the next two characters
             } else {
                 // Otherwise, count the character as one byte
                 count += 1;
             }
         }
     
         return count;
      }

      
      
   }, ICO);
}
